import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'

import getLinkHref from 'lib/get-link-href'

interface IProps {
  /* icon图片路径 */
  icon?: string
  /* 左边的文本内容 */
  leftContent: string
  /* 右边的文本内容 */
  rightContent: string
  /* link前端路径 */
  href?: string
  /* link后端路径 */
  as?: string
  onClick?(): void
}

export default function Header({
  icon,
  leftContent,
  rightContent,
  href,
  as,
  onClick,
}: IProps) {
  return (
    <header
      className={classNames('header', {
        'no-icon': !icon,
      })}
    >
      <span
        className={classNames('title', {
          'title-icon': icon,
        })}
      >
        {leftContent}
      </span>
      {href && as ? (
        <Link href={href} as={getLinkHref(as)}>
          <span
            className="more icon"
            onClick={() => {
              onClick && onClick()
            }}
          >
            {rightContent}
            <span className="icon-arrow-ic-r arrow-right" />
          </span>
        </Link>
      ) : (
        <span className="more text">{rightContent}</span>
      )}
      <style jsx>
        {`
          .brands {
            width: 390px;
            min-height: 272px;
            font-size: 16px;
          }
          .header {
            height: 60px;
            line-height: 60px;
            padding: 0 24px 0 12px;
            border-bottom: 1px solid #e6e6e6;
          }
          .header.no-icon {
            position: relative;
            padding-left: 26px;
          }
          .header.no-icon::before {
            content: '';
            position: absolute;
            top: 21px;
            left: 16px;
            width: 6px;
            height: 18px;
            background: #ffe100;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
          }
          .title-yellow-square {
            position: relative;
          }
          .title-icon::before {
            content: '';
            display: inline-block;
            width: 36px;
            height: 36px;
            margin-right: 4px;
            vertical-align: middle;
            background: url(${icon ? require(`static/${icon}_ic@3x.png`) : ''})
              no-repeat center / 36px 36px;
          }
          .more {
            float: right;
          }
          .more:hover {
            cursor: pointer;
          }
          .text {
            font-size: 12px;
            color: #999;
          }
          .arrow-right {
            display: inline-block;
            font-size: 16px;
            vertical-align: text-top;
            margin-top: 1.5px;
            margin-left: 4px;
          }
        `}
      </style>
    </header>
  )
}
